import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { productService } from '../services/api';

const Home = () => {
  const [featuredProducts, setFeaturedProducts] = useState({
    chemical: [],
    mechanical: []
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchFeaturedProducts = async () => {
      try {
        const products = await productService.getFeaturedProducts();

        // DO NOT SLICE HARD – allow up to 4 safely
        setFeaturedProducts({
          chemical: products.chemical ? products.chemical.slice(0, 4) : [],
          mechanical: products.mechanical ? products.mechanical.slice(0, 4) : []
        });
      } catch (err) {
        setError('Failed to load products');
        setFeaturedProducts({ chemical: [], mechanical: [] });
      } finally {
        setLoading(false);
      }
    };

    fetchFeaturedProducts();
  }, []);

  if (loading) {
    return (
      <div className="hero home-hero">
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <h1>ARYAN ENGINEERING</h1>
          <p>Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <>
      {/* HERO */}
      <section className="hero home-hero">
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <h1>ARYAN ENGINEERINGS</h1>
          <p>
            Manufacturer of all type of Mechanical Shaft Seals and Chemical Process Pumps.
          </p>
          <div className="hero-btns">
            <Link to="/mechanical" className="hero-btn">
              MECHANICAL SHAFT SEALS
            </Link>
            <Link to="/chemical" className="hero-btn">
              CHEMICAL PROCESS PUMPS
            </Link>
          </div>
        </div>
      </section>

      {/* ===== CHEMICAL ===== */}
      <h2>Featured Chemical Process Pumps</h2>

      <div className="home-product-grid">
        {featuredProducts.chemical.map(product => (
          <Link
            key={product.id}
            to="/chemical"
            className="home-product-card"
          >
            <img src={product.image} alt={product.name} />
            <div className="home-product-card-name">{product.name}</div>
            <div className="home-product-card-divider"></div>
          </Link>
        ))}
      </div>

      {featuredProducts.chemical.length > 0 && (
        <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
          <Link to="/chemical" style={{ textDecoration: 'none' }}>
            <div className="hero-btn" style={{ fontWeight: 600, color: 'var(--secondary-color)' }}>
              Explore More →
            </div>
            <div
              style={{
                width: '50px',
                height: '3px',
                background: 'var(--primary-color)',
                margin: '8px auto 0',
                borderRadius: '2px'
              }}
            />
          </Link>
        </div>
      )}

      {/* ===== MECHANICAL ===== */}
      <h2>Featured Mechanical Shaft Seals</h2>

      <div className="home-product-grid">
        {featuredProducts.mechanical.map(product => (
          <Link
            key={product.id}
            to="/mechanical"
            className="home-product-card"
          >
            <img src={product.image} alt={product.name} />
            <div className="home-product-card-name">{product.name}</div>
            <div className="home-product-card-divider"></div>
          </Link>
        ))}
      </div>

      {featuredProducts.mechanical.length > 0 && (
        <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
          <Link to="/mechanical" style={{ textDecoration: 'none' }}>
            <div className="hero-btn" style={{ fontWeight: 600, color: 'var(--secondary-color)' }}>
              Explore More →
            </div>
            <div
              style={{
                width: '50px',
                height: '3px',
                background: 'var(--primary-color)',
                margin: '8px auto 0',
                borderRadius: '2px'
              }}
            />
          </Link>
        </div>
      )}

      {error && (
        <div style={{ color: 'red', textAlign: 'center', padding: '20px' }}>
          {error}
        </div>
      )}
    </>
  );
};

export default Home;